import React from 'react'
import { connect } from 'react-redux'
import { pick, sortBy, toInteger } from 'lodash'
import qs from 'qs'

import { load, schemas } from 'api'
import { applyHOCs } from 'helpers'
import { linkTo } from 'event-taxonomy'

import EmbedLayout from '../EmbedLayout'
import EmbedList from './EmbedList'

const DEFAULT_LIMIT = 25
const MAX_LIMIT = 50

const parseLimit = (raw) => {
  const n = toInteger(raw)
  if (!n || n < 1) return DEFAULT_LIMIT
  return Math.min(n, MAX_LIMIT)
}

const parseView = (raw) => (raw === 'upcoming' ? 'upcoming' : 'library')

const buildWebinarsUrl = (view, query, limit) => {
  const filters = pick(query, 'type')
  if (query.category) filters.category_id = toInteger(query.category)
  if (view === 'upcoming') {
    filters.upcoming = true
  } else {
    filters.past = true
  }
  return `/v2/webinars?${qs.stringify({
    filters,
    limit,
    order: view === 'upcoming' ? 'asc' : 'desc'
  })}`
}

const buildSessionSalesUrl = (limit) =>
  `/v2/session_sales?${qs.stringify({ limit })}`

const EmbedWebinarsPage = ({ webinars, sessionSales, view, loadStatus }) => {
  const webinarItems = (webinars || []).map((w) => ({
    key: `w-${w.id}`,
    kind: 'webinar',
    title: w.title,
    href: linkTo({ type: 'webinar', target: w }),
    start: w.start_at,
    end: w.end_at,
    facilitator: w.facilitator
  }))

  const sessionSaleItems = (sessionSales || []).map((s) => ({
    key: `s-${s.id}`,
    kind: 'session_sale',
    title: s.title,
    href: linkTo({ type: 'session_sale', target: s }),
    start: s.advertised_start_date,
    end: s.advertised_end_date,
    facilitator: null
  }))

  const items = view === 'upcoming'
    ? sortBy(webinarItems.concat(sessionSaleItems), (item) => item.start || '')
    : webinarItems

  const loading =
    loadStatus.webinars.loading ||
    (view === 'upcoming' && loadStatus.sessionSales.loading)

  return (
    <EmbedLayout>
      <EmbedList
        items={items}
        loading={loading}
        showDateTime={view === 'upcoming'}
      />
    </EmbedLayout>
  )
}

EmbedWebinarsPage.propTypes = {
  webinars: React.PropTypes.array,
  sessionSales: React.PropTypes.array,
  view: React.PropTypes.string.isRequired,
  loadStatus: React.PropTypes.object.isRequired
}

export default applyHOCs([
  connect((state, { location }) => ({
    view: parseView(location.query.view)
  })),
  load({
    webinars: {
      urlSelector: (state, props) => {
        const view = parseView(props.location.query.view)
        const limit = parseLimit(props.location.query.limit)
        return buildWebinarsUrl(view, props.location.query, limit)
      },
      schema: [schemas.webinar]
    },
    sessionSales: {
      urlSelector: (state, props) => {
        if (parseView(props.location.query.view) !== 'upcoming') return null
        return buildSessionSalesUrl(parseLimit(props.location.query.limit))
      },
      schema: [schemas.sessionSale]
    }
  })
])(EmbedWebinarsPage)
